export const stepOption = [
    {
        value: "1", title: "Выявление новых случаев", type: "input", level: 1,
        data: [13395, 13866, 13933, 14446, 15438, 15924, 16633, 16819, 16601, 14622],
        dataPredictor: 1255,
        cr: `${process.env.PUBLIC_URL}/images/pdf/cr/KR11.pdf`
    },
    {
        value: "s1", title: "Стадия I", typex: "stage", col: 0.5, level: 2,
        data: [4498, 5186, 5475, 5966, 6716, 7433, 8199, 8606, 9058, 7910], dataPredictor: 385
    },
    {
        value: "s2", title: "Стадия II", typex: "stage", col: 1.5, level: 2,
        data: [4458, 4397, 4227, 4327, 4522, 4376, 4271, 4218, 3895, 3395], dataPredictor: 15,
    },
    {
        value: "s3", title: "Стадия III", typex: "stage", col: 2.5, level: 2,
        data: [2593, 2423, 2371, 2338, 2324, 2138, 2142, 2111, 1820, 1756], dataPredictor: 18
    },
    {
        value: "s4", title: "Стадия IV", typex: "stage", col: 3.5, level: 2,
        fixed: "toTable",
        data: [1284, 1393, 1439, 1409, 1482, 1537, 1641, 1593, 1595, 1371], dataPredictor: 70
    },

    {value: "p1", title: "Прогрессирование (вне модели)", col: 2, level: 3},

    {value: "t1", title: "Целевая группа (новые)", col: 2, level: 4},
    {value: "mq", title: "ECOG (выбор терапии)", col: 2, level: 5},

    {value: "m1", title: "Цисплатин +", col: 1, level: 6},
    {value: "m2", title: "Цисплатин -", col: 3, level: 6},

    {value: "p2", title: "Прогрессирование (Цисплатин)", col: 1, level: 7},
    {value: "m3", title: "PD-L1 +", col: 2, level: 7},
    {value: "m4", title: "PD-L1 -", col: 3, level: 7},

    {value: "p3", title: "Прогрессирование (PD-L1-)", col: 3, level: 8},

    {
        value: "h1", title: "Пембро/Атезо (прогрессирование цисплатин)", typex: "treat", col: 1, level: 9,
        // getCont: {c1: 0.6}
    },
    {
        value: "h2", title: "Атезо (PD-L1+)", typex: "treat", col: 2, level: 9,
        // getCont: {c1: 0.8}
    },
    {
        value: "h3", title: "Пембро/Атезо (PD-L1- прогрессирование)", typex: "treat", col: 3, level: 9,
        // getCont: {c1: 0.65}
    },

]
export const stepConnection = [
    {source: "1", target: "s1", label: "", generator: "S1"},
    {source: "1", target: "s2", label: "", generator: "S2"},
    {source: "1", target: "s3", label: "", generator: "S3"},
    {source: "1", target: "s4", label: "", generator: "S4"},

    {source: "s2", target: "p1", label: "25%", sender: {value: "0.25", ttl: "1"}, mutator: {name: "M1", task: ["sender", "value"]}},
    {source: "s3", target: "p1", label: "30%", sender: {value: "0.30", ttl: "1"}, mutator: {name: "M2", task: ["sender", "value"]}},

    {source: "p1", target: "t1", label: "100%", sender: {value: "0.25", ttl: "1"}, hideLabel: true},
    {source: "s4", target: "mq", label: "80%", sender: {value: "0.30", ttl: "0"}},

    {source: "t1", target: "mq", label: "", sender: {value: "0.95", ttl: "0"}},

    {source: "mq", target: "m1", label: "55%", sender: {value: "0.40", ttl: "0"}},
    {source: "mq", target: "m2", label: "45%", sender: {value: "0.45", ttl: "0"}},

    {source: "m1", target: "p2", sender: {value: "0.65", ttl: "0"}},

    {source: "m2", target: "m3", label: "43%", sender: {value: "0.30", ttl: "0"}},
    {source: "m2", target: "m4", label: "57%", sender: {value: "0.70", ttl: "0"}},

    {source: "p2", target: "h1", sender: {value: "0.30", ttl: "0"}},
    {source: "m3", target: "h2", sender: {value: "0.95", ttl: "0"}},
    {source: "m4", target: "p3", sender: {value: "0.70", ttl: "0"}},
    {source: "p3", target: "h3", sender: {value: "0.95", ttl: "0"}}
]
export const modeling = [
    {
        value: "h1x", source: "h1", title: "Атезо (прогрессирование цисплатин)", selector: 'H1', kmv:
            {
                A: [0.6, 0.4],
                B: [0.8, 0.7]
            },
    },
    {
        value: "h2x", source: "h2", title: "Атезо (PD-L1 +)", selector: 'H2', kmv:
            {
                A: [0.6, 0.4],
                B: [0.8, 0.7]
            },
    },
    {
        value: "h3x", source: "h3", title: "Атезо (DP-L1 -)", selector: 'H3', kmv:
            {
                A: [0.6, 0.4],
                B: [0.8, 0.7]
            },
    },
]
export const data = [
    {
        name: '2014',
        s1: 4000,
        s2: 2400,
        s3: 2400,
        s4: 1500,
    },
    {
        name: '2016',
        s1: 3000,
        s2: 1398,
        s3: 2210,
        s4: 5280,
    },
    {
        name: '2016',
        s1: 2000,
        s2: 9800,
        s3: 2290,
        s4: 2016,
    },
    {
        name: '2017',
        s1: 2780,
        s2: 3908,
        s3: 2000,
        s4: 1500,
    },
    {
        name: '2018',
        s1: 1890,
        s2: 4800,
        s3: 2181,
        s4: 3181,
    },
    {
        name: '2019',
        s1: 2390,
        s2: 3800,
        s3: 2500,
        s4: 2000,
    },
    {
        name: '2020',
        s1: 3490,
        s2: 4300,
        s3: 2100,
        s4: 1281,
    },
];

export const mainTrends = {
    stageI_II: {
        data: [64.57,  66.86,  69.11,  69.63,  71.25,  72.79,  74.16,  74.97,  76.25,  78.03,  77.32],
        ltr: 0.21
    },
    live5y: {
        data: [47.66,  48.89,  48.90,  49.42,  49.97,  50.27,  51.92,  52.53,  52.74,  54.66,  55.84],
        ltr: 0.76
    },
    live1y: {
        data: [21.31,  19.47,  18.93,  17.93,  17.47,  16.53,  16.55,  14.91,  14.45,  14.27,  14.01],
        ltr: -0.71
    },
    dnl: {
        data: [49,        50,     51,     52,    53,      54,     55, 56,      57,   58,    59],
        ltr: 1
    },
    live1yttl: {
        data: [27.38, 26.09, 25.32, 24.77, 23.58, 23.25, 22.51, 22.25, 21.68, 20.60],
        ltr: -0.69
    },
    live5yttl: {
        data: [51.34,	51.07,	51.67,	52.43,	52.92,	53.34,	53.94,	54.45,	55.33,	56.57],
        ltr: 0.58
    },
}

const Model = {
    stepOption, stepConnection, mainTrends, data, modeling,
    defaultStrategy: {
        H1A: '0', H2A: '0', H3A: '0',
        H1B: '10', H2B: '20', H3B: '40',
        M1: '25',
        M2: '30'
    },
    name: "Рак мочевого пузыря",
    options: {
        showTrends: true,
        mainView: {
            title: "Выявление по стадиям",
            lines: [
                {key: "s1", title: "I стадия"},
                {key: "s2", title: "II стадия"},
                {key: "s3", title: "III стадия"},
                {key: "s4", title: "IV стадия"},
            ]
        }
    },
    vars: {
        strategy: [
            {title: "Доля направленных на Атезолизумаб после прогрессирование на Цисплатине, %", prefix: "H1"},
            {title: "Доля направленных на Атезолизумаб PD-L1+, %", prefix: "H2"},
            {title: "Доля направленных на Атезолизумаб PD-L1-, %", prefix: "H3"},
        ],
        mutation: [
            {title: "Прогрессирование после II стадии, %", prefix: "M1"},
            {title: "Прогрессирование после III стадии, %", prefix: "M2"},
        ]
    },
}

export default Model